import React, { useEffect, useState } from 'react';
import { Typography, Box, Button, Grid, List, ListItem } from '@mui/material';
import Select from 'react-select';
import { ConstantActions, DecisionBoardActions } from '../../../Services/_actions';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import ModalForms from '../../Shared/Modals';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import LoadingButton from '../../Shared/Loading/index.tsx';
import { convertToReadableFormat } from '../../../utils/helper.jsx';

const CampaignAssignModal = (props) => {
  const { open, onClose, title = '', proposalData, isUnassignUser = false } = props;
  const DecisionBoard = DecisionBoardActions();
  const ConstantAssign = ConstantActions();
  const { showSnackBar } = useSnackBar();
  const [owners, setOwners] = useState<number[]>([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userList, setUserList] = useState([]);
  const [multiSelect, setMultiSelect] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleOwnerToggle = (userId) => {
    setSelectedUsers((prevUsers) =>
      prevUsers.map((user) => (user.id === userId ? { ...user, is_owner: !user.is_owner } : user))
    );
    setMultiSelect((prevUsers) =>
      prevUsers.map((user) =>
        user.id === userId ? { ...user, is_owner: !user.is_owner } : user
      )
    );
  };

  const handleMultiSelect = (selectedOptions) => {
    if (selectedOptions.length > 4) {
      showSnackBar('You can assign to a maximum of 4 users only.', 'warning');
      return;
    }
    setMultiSelect(selectedOptions);
  };

  const CampaignAssignment = async () => {
    const campaignId = proposalData?.proposal?.proposal_id || proposalData?.campaign_id;
    const users = [...selectedUsers, ...multiSelect]
    const payload = {
      // campaign_id: campaignId,
      to: users,
      // to: multiSelect.map((user) => ({
      //   id: user.id,
      //   first_name: user.first_name,
      //   last_name: user.last_name,
      //   email: user.email,
      //   label: user.username,
      //   username: user.username,
      //   profile_id: user.profile_id,
      //   role_id: user.role_id,
      //   is_owner: user.is_owner, //owners.includes(user.id),
      // })),
      campaign_id: campaignId,
    };
    try {
      setIsLoading(true);
      const res = await DecisionBoard.CampaignAssignment(payload);
      if (res?.status === 200) {
        showSnackBar('Campaign assigned successfully', 'success');
        onClose(null, 'success');
      } else {
        showSnackBar(`Failed: ${res?.data?.system_error || 'Unknown error'}`, 'error');
      }
    } catch (err) {
      showSnackBar('Server error. Please try again.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const CampaignUnAssignment = async () => {
    try {
      const campaignId = proposalData?.proposal?.proposal_id
      const payload = {
        to: [...multiSelect],
        campaign_id: campaignId,
      };
      setIsLoading(true);
      const res = await DecisionBoard.CampaignUnAssignment(payload);
      if (res?.status === 200) {
        showSnackBar('Campaign unassigned successfully', 'success');
        onClose(null, 'success');
      } else {
        showSnackBar('Campaign unassigned failed', 'error');
      }
    } catch (error) {
      showSnackBar(error?.toString() ?? 'Server error. Please try again.', 'error');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!open) {
      setSelectedOption(null);
      setUserList([]);
      setMultiSelect([]);
      setOwners([]);
    }
  }, [open]);

  useEffect(() => {
    if (proposalData?.assignment_detail) {
      const output = (proposalData?.assignment_detail ?? [])?.map((item) => ({
        assigned_by: item?.assigned_by,
        id: item?.assigned_to?.assigned_to_id,
        username: item?.assigned_to?.assigned_to_name,
        organisation_name: item?.assigned_to?.organisation_name,
        organisation_id: item?.assigned_to?.organisation_id,
        is_owner: item?.assigned_to?.is_owner,
      }));
      setSelectedUsers(output);
    }
  }, [proposalData]);

  return (
    <ModalForms
      show={open}
      handleClose={() => onClose(null, 'cancel')}
      modalHeader={'Assign Campaign to Operations Manager'}
      modalBody={
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            {!isUnassignUser && (
              <Grid item xs={12}>
                <OrganisationDropdown
                  value={selectedOption}
                  onChange={async (org) => {
                    setSelectedOption(org);
                    if (org?.organisation_id) {
                      const res: any = await ConstantAssign.getUserMinimalList(org?.organisation_id);
                      setUserList(res ?? []);
                    }
                  }}
                  label="Select Organisation"
                //                             // error={!selectedOption}
                //                             // errorMessage="Please select an organisation"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <SearchableDropdown
                // options={isUnassignUser ? selectedUsers : userList}
                options={
                  isUnassignUser
                    ? selectedUsers
                    : userList.filter(
                      (user) =>
                        !selectedUsers.some(
                          (assignedUser) => assignedUser.id === user.id
                        )
                    )
                }
                value={multiSelect}
                labelKey="username"
                valueKey="id"
                onChange={handleMultiSelect}
                multiSelect={true}
              />
            </Grid>
            {(!isUnassignUser && [...multiSelect, ...selectedUsers].length > 0) && (
              <Grid item xs={12}>
                <Typography variant="subtitle1">Assigned Users</Typography>
                <ListItem>
                  <Typography variant="subtitle2" style={{ width: 100 }}>
                    Is Owner
                  </Typography>
                  <Typography variant="subtitle2">Users</Typography>
                </ListItem>

                <List dense>
                  {multiSelect.map((user) => (
                    <ListItem key={user.id}>
                      <div style={{ width: 100 }}>
                        <input
                          type="checkbox"
                          checked={user.is_owner ?? false}
                          onChange={() => handleOwnerToggle(user.id)}
                          style={{ marginRight: 8 }}
                        />
                      </div>
                      {convertToReadableFormat(user.username) ?? user.username}
                    </ListItem>
                  ))}
                  {selectedUsers?.map((item, index) => {
                    return (
                      <ListItem key={`existing-${index}`}>
                        <div style={{ width: 100 }}>
                          <input
                            type="checkbox"
                            checked={item.is_owner}
                            onChange={() => handleOwnerToggle(item?.id)}
                            style={{ marginRight: 8 }}
                          />
                        </div>
                        {convertToReadableFormat(item.username) ?? item.username}
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
            )}
          </Grid>
        </Box>
      }
      modalId={title}
      size="sm"
      modalFooter={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={() => onClose(null, 'cancel')} variant="outlined" size="small">
            Cancel
          </Button>
          {/* <Button
            onClick={CampaignAssignment}
            variant="contained"
            color="primary"
            size="small"
          // disabled={!selectedOption || multiSelect.length === 0}
          >
            Assign
          </Button> */}
          <LoadingButton
            onClickButton={isUnassignUser ? CampaignUnAssignment : CampaignAssignment}
            isDisabled={isLoading}
            isLoading={isLoading}
            buttonName={isUnassignUser ? 'Unassign' : 'Assign'}
          />
        </Box>
      }
    />
  );
};

export default CampaignAssignModal;
